var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentWrap,_vm._b({tag:"component",staticClass:"link",class:{ 'link-text': _vm.isText },attrs:{"href":_vm.linkTo,"target":_vm.target,"to":_vm.linkTo}},'component',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }